import React from "react";
const AuthUserContext = React.createContext(null);
const RegisterContext = React.createContext(null);
const JupyterContext = React.createContext(null);
const MatlabContext = React.createContext(null);
const SuperAccessContext = React.createContext(null);
export { AuthUserContext, RegisterContext, JupyterContext, MatlabContext, SuperAccessContext };
